/* Landing produit — comportements dynamiques
   Onglets, galerie, offres, compte à rebours, boutons d'achat automatiques. */
(function () {
  if (window.__lpLanding) return;
  window.__lpLanding = true;

  /* ---------- Utilitaires ---------- */
  function formatMoney(cents, format) {
    cents = Math.round(Number(cents) || 0);
    function fmt(decimals, thousands, dec) {
      var s = (cents / 100).toFixed(decimals).split('.');
      s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return s[1] ? s[0] + dec + s[1] : s[0];
    }
    var map = {
      amount: function () { return fmt(2, ',', '.'); },
      amount_no_decimals: function () { return fmt(0, ',', '.'); },
      amount_with_comma_separator: function () { return fmt(2, '.', ','); },
      amount_no_decimals_with_comma_separator: function () { return fmt(0, '.', ','); },
      amount_with_space_separator: function () { return fmt(2, ' ', ','); },
      amount_with_apostrophe_separator: function () { return fmt(2, "'", '.'); }
    };
    return String(format || '{{amount_with_comma_separator}} €').replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      return (map[key] || map.amount_with_comma_separator)();
    });
  }

  /* ---------- Onglets / accordéons ---------- */
  function setOpen(item, open) {
    item.classList.toggle('is-open', open);
    var t = item.querySelector('[data-lp-acc-trigger]');
    if (t) t.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  function initAccordions(root) {
    root.querySelectorAll('[data-lp-acc-trigger]').forEach(function (btn) {
      if (btn.__lp) return;
      btn.__lp = true;
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-lp-acc-item]');
        var group = item.closest('[data-lp-acc]');
        var willOpen = !item.classList.contains('is-open');
        if (willOpen && group && group.getAttribute('data-single') === 'true') {
          group.querySelectorAll('[data-lp-acc-item].is-open').forEach(function (other) {
            if (other !== item) setOpen(other, false);
          });
        }
        setOpen(item, willOpen);
      });
    });
  }

  /* ---------- Galerie ---------- */
  function initGallery(root) {
    root.querySelectorAll('[data-lp-gallery]').forEach(function (g) {
      if (g.__lp) return;
      g.__lp = true;
      var track = g.querySelector('[data-lp-track]');
      var thumbs = g.querySelectorAll('[data-lp-thumb]');
      if (!track) return;
      function index() { return Math.round(track.scrollLeft / track.clientWidth); }
      function go(i) {
        var n = track.children.length;
        i = (i + n) % n;
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      }
      var prev = g.querySelector('[data-lp-prev]');
      var next = g.querySelector('[data-lp-next]');
      if (prev) prev.addEventListener('click', function () { go(index() - 1); });
      if (next) next.addEventListener('click', function () { go(index() + 1); });
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = index();
          thumbs.forEach(function (t, j) { t.classList.toggle('is-active', i === j); });
          var active = thumbs[i];
          if (active && active.parentNode.scrollWidth > active.parentNode.clientWidth) {
            active.parentNode.scrollTo({ left: active.offsetLeft - 40, behavior: 'smooth' });
          }
        });
      });
    });
  }

  /* ---------- Compte à rebours (date de fin réelle) ---------- */
  function initCountdowns(root) {
    root.querySelectorAll('[data-lp-countdown]').forEach(function (el) {
      if (el.__lp) return;
      el.__lp = true;
      var end = Date.parse(el.getAttribute('data-end'));
      if (isNaN(end)) return;
      var d = el.querySelector('[data-d]'), dWrap = el.querySelector('[data-d-wrap]');
      var h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
      var wrap = el.closest('[data-lp-bar]');
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var diff = Math.max(0, end - Date.now());
        if (diff === 0) {
          clearInterval(timer);
          if (wrap && wrap.getAttribute('data-hide-expired') === 'true') wrap.style.display = 'none';
        }
        var t = Math.floor(diff / 1000);
        var days = Math.floor(t / 86400);
        if (d) { d.textContent = days; dWrap.hidden = days === 0; }
        h.textContent = pad(Math.floor((t % 86400) / 3600));
        m.textContent = pad(Math.floor((t % 3600) / 60));
        s.textContent = pad(t % 60);
      }
      var timer = setInterval(tick, 1000);
      tick();
    });
  }

  /* ---------- Formulaire produit + offres ---------- */
  var main = null; // état du formulaire principal

  function initProductForm(root) {
    root.querySelectorAll('[data-lp-main-form]').forEach(function (form) {
      if (form.__lp) return;
      form.__lp = true;
      var dataEl = form.querySelector('[data-lp-product-json]');
      var data = {};
      try { data = JSON.parse(dataEl ? dataEl.textContent : '{}'); } catch (e) {}
      var variants = data.variants || [];
      var state = {
        form: form,
        moneyFormat: data.moneyFormat,
        variant: variants.filter(function (v) { return v.id === data.selected; })[0] || variants[0],
        offers: Array.prototype.slice.call(form.querySelectorAll('[data-lp-offer]')),
        idInput: form.querySelector('input[name="id"]'),
        qtyInput: form.querySelector('input[name="quantity"]'),
        atc: form.querySelector('[data-lp-atc]'),
        label: '',
        price: ''
      };
      main = state;

      function findVariant(id) { return variants.filter(function (v) { return v.id === Number(id); })[0]; }

      function recalc() {
        state.offers.forEach(function (o) {
          if (o.getAttribute('data-fixed')) return;
          if (o.getAttribute('data-override') === 'true') return;
          var v = state.variant; if (!v) return;
          var qty = Number(o.getAttribute('data-qty')) || 1;
          var disc = Number(o.getAttribute('data-discount')) || 0;
          var total = v.price * qty;
          var final = Math.floor(total * (100 - disc) / 100);
          var compare = v.compare > v.price ? v.compare * qty : (disc > 0 ? total : 0);
          var p = o.querySelector('[data-lp-offer-price]');
          var c = o.querySelector('[data-lp-offer-compare]');
          if (p) p.innerHTML = formatMoney(final, state.moneyFormat);
          if (c) { c.innerHTML = compare > final ? formatMoney(compare, state.moneyFormat) : ''; }
          o.setAttribute('data-price', final);
        });
      }

      function apply() {
        var selected = state.offers.filter(function (o) { return o.querySelector('input').checked; })[0];
        state.offers.forEach(function (o) { o.classList.toggle('is-selected', o === selected); });
        var v = state.variant;
        var qty = 1;
        if (selected) {
          var fixed = selected.getAttribute('data-fixed');
          if (fixed) v = findVariant(fixed) || v;
          qty = Number(selected.getAttribute('data-qty')) || 1;
          state.label = selected.getAttribute('data-label') || '';
          var priceNode = selected.querySelector('[data-lp-offer-price]');
          state.price = priceNode ? priceNode.innerHTML : '';
        } else if (v) {
          state.label = v.title;
          state.price = formatMoney(v.price, state.moneyFormat);
        }
        if (v && state.idInput) state.idInput.value = v.id;
        if (state.qtyInput) state.qtyInput.value = qty;
        if (state.atc) {
          var available = v ? v.available : true;
          state.atc.disabled = !available;
          var labelEl = state.atc.querySelector('[data-lp-atc-label]');
          if (labelEl) labelEl.textContent = available ? state.atc.getAttribute('data-label') : state.atc.getAttribute('data-soldout');
        }
        updateCtas();
      }

      form.addEventListener('change', function (e) {
        if (e.target.matches('[data-lp-variant-select]')) {
          state.variant = findVariant(e.target.value) || state.variant;
          recalc();
        }
        apply();
      });
      recalc();
      apply();
    });
  }

  function updateCtas() {
    if (!main) return;
    document.querySelectorAll('[data-lp-cta-price]').forEach(function (n) { n.innerHTML = main.price; });
    document.querySelectorAll('[data-lp-cta-offer]').forEach(function (n) { n.textContent = main.label; });
  }

  /* ---------- Clic sur un bouton d'achat (sections + automatiques) ---------- */
  function scrollToOffers() {
    var target = document.querySelector('[data-lp-offers]') || (main && main.form);
    if (!target) return false;
    var y = target.getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo({ top: y, behavior: 'smooth' });
    target.classList.remove('is-flash');
    void target.offsetWidth;
    target.classList.add('is-flash');
    return true;
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lp-buy]');
    if (!btn) return;
    e.preventDefault();
    var mode = btn.getAttribute('data-lp-buy');
    if (mode === 'add' && main && main.form && main.atc && !main.atc.disabled) {
      if (typeof main.form.requestSubmit === 'function') main.form.requestSubmit(main.atc);
      else main.form.submit();
      return;
    }
    scrollToOffers();
  });

  /* ---------- Insertion automatique d'un bouton toutes les N sections ---------- */
  function sectionWrapper(el) {
    return el.closest('.shopify-section') || el;
  }
  function insertAutoCtas() {
    document.querySelectorAll('.lp-auto-cta').forEach(function (n) { n.remove(); });
    var cfgEl = document.querySelector('[data-lp-autocta]');
    if (!cfgEl || cfgEl.getAttribute('data-enabled') !== 'true') return;
    var tpl = document.getElementById(cfgEl.getAttribute('data-template'));
    if (!tpl) return;
    var every = Math.max(1, Number(cfgEl.getAttribute('data-every')) || 2);
    var start = sectionWrapper(cfgEl);
    var sections = Array.prototype.slice.call(document.querySelectorAll('[data-lp-section]'))
      .map(sectionWrapper)
      .filter(function (w, i, arr) { return arr.indexOf(w) === i; })
      .filter(function (w) { return start.compareDocumentPosition(w) & Node.DOCUMENT_POSITION_FOLLOWING; });

    var count = 0;
    sections.forEach(function (w) {
      var sec = w.matches('[data-lp-section]') ? w : w.querySelector('[data-lp-section]');
      if (!sec || getComputedStyle(sec).display === 'none') return;
      if (sec.hasAttribute('data-lp-has-cta')) { count = 0; return; }
      count++;
      if (count >= every && !sec.hasAttribute('data-lp-no-cta')) {
        var node = tpl.content.firstElementChild.cloneNode(true);
        var scheme = (sec.className.match(/lp-scheme-\w+/) || ['lp-scheme-light'])[0];
        node.classList.add(scheme);
        w.insertAdjacentElement('afterend', node);
        count = 0;
      }
    });
    updateCtas();
  }

  /* ---------- Avis : « Voir plus » ---------- */
  function initMore(root) {
    root.querySelectorAll('[data-lp-more]').forEach(function (btn) {
      if (btn.__lp) return;
      btn.__lp = true;
      var step = Number(btn.getAttribute('data-step')) || 4;
      var list = document.getElementById(btn.getAttribute('aria-controls'));
      btn.addEventListener('click', function () {
        var hidden = list.querySelectorAll('.is-hidden');
        for (var i = 0; i < Math.min(step, hidden.length); i++) hidden[i].classList.remove('is-hidden');
        if (list.querySelectorAll('.is-hidden').length === 0) btn.parentNode.style.display = 'none';
      });
    });
  }

  function init(root) {
    root = root || document;
    initAccordions(root);
    initGallery(root);
    initCountdowns(root);
    initProductForm(root);
    initMore(root);
  }

  function boot() { init(document); insertAutoCtas(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* Éditeur de thème Shopify : rafraîchit après chaque modification */
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder', 'shopify:block:select'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      if (evt === 'shopify:section:load') {
        var form = e.target.querySelector('[data-lp-main-form]');
        if (form) main = null;
        init(e.target);
      }
      if (evt === 'shopify:block:select') {
        var item = e.target.closest ? e.target.closest('[data-lp-acc-item]') : null;
        if (item) setOpen(item, true);
        return;
      }
      setTimeout(insertAutoCtas, 50);
    });
  });
})();
